export default __webpack_public_path__ + "static/media/shortcut_userinfo.d3396a01.svg";